"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestAppId = void 0;
exports.requestAppId = {
    Wrap: {
        appIds: [0],
        default: 0,
    },
    WrapAndSwap: {
        appIds: [1, 20],
        default: 20,
    },
};
//# sourceMappingURL=request-types.js.map